<template>
  <ul
    v-if="pager.totalPages && pager.totalPages > 1"
    class="pagination"
  >
    <li
      class="page-item first"
      :class="{ disabled: pager.currentPage === 1 }"
    >
      <a
        class="page-link"
        @click="setPage(1)"
      >
        <i
          class="fa fa-angle-double-left"
          aria-hidden="true"
        />
      </a>
    </li>
    <li
      class="page-item previous"
      :class="{ disabled: pager.currentPage === 1 }"
    >
      <a
        class="page-link"
        @click="setPage(pager.currentPage - 1)"
      ><i
        class="fa fa-angle-left"
        aria-hidden="true"
      /></a>
    </li>
    <li
      v-for="page in pager.pages"
      :key="page"
      class="page-item page-number"
      :class="{ active: pager.currentPage === page }"
    >
      <a
        v-if="shouldShowPageButton(page, pager.currentPage)"
        class="page-link"
        @click="setPage(page)"
      >
        {{ page }}
      </a>
    </li>
    <li
      class="page-item next"
      :class="{ disabled: pager.currentPage === pager.totalPages }"
    >
      <a
        class="page-link"
        @click="setPage(pager.currentPage + 1)"
      ><i
        class="fa fa-angle-right"
        aria-hidden="true"
      /></a>
    </li>
    <li
      class="page-item last"
      :class="{ disabled: pager.currentPage === pager.totalPages }"
    >
      <a
        class="page-link"
        @click="setPage(pager.totalPages)"
      ><i
        class="fa fa-angle-double-right"
        aria-hidden="true"
      /></a>
    </li>
  </ul>
</template>

<script>

/**
 * Reuseable pagination buttons.
 *
 * @displayName Pagination Buttons Component
 */
export default {
  name: 'PaginationButtons',
  components: {},
  props: ['pages', 'currentPage', 'totalPages', 'isLoading'],
  data () {
    return {
      initialPage: 1
    }
  },
  computed: {
    /**
     * The current pagination status
     *
     * @public
     */
    pager: function () {
      return {
        pages: this.pages,
        currentPage: this.currentPage,
        totalPages: this.totalPages
      }
    }
  },
  /**
   * Gets called when component is created
   *
   * @public
   */
  created () {
    if (!this.$listeners.changePage) {
      throw new Error('Missing required event listener: "changePage"')
    }
  },
  mounted () {},
  methods: {
    /**
     * Gets called when user paginates.
     *
     * @public
     */
    setPage (page) {
      if (page) {
        // emit change page event to parent component
        this.$emit('changePage', page)
      }
    },
    /**
     * Assert if page number button should render
     *
     * @returns boolean
     */
    shouldShowPageButton (page, currentPage) {
      let leftBuffer = 2
      let rightBuffer = 2
      // Always show five 'numbered' buttons
      if (currentPage === this.totalPages) {
        leftBuffer = 4
      }
      if (currentPage === (this.totalPages - 1)) {
        leftBuffer = 3
      }
      if (currentPage === 1) {
        rightBuffer = 4
      }
      if (currentPage === 2) {
        rightBuffer = 3
      }
      return page >= (currentPage - leftBuffer) && page <= (currentPage + rightBuffer)
    }
  }
}
</script>

<style scoped>

</style>
